<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item label="訂單編號" class="searchItem">
              <el-input v-model="listMenuForm.orderId"
                        @change="listMenuForm.orderId=listMenuForm.orderId.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="用戶賬號" class="searchItem">
              <el-input v-model="listMenuForm.userAccount"
                        @change="listMenuForm.userAccount=listMenuForm.userAccount.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="支付方式" class="searchItem">
              <el-select v-model="listMenuForm.payWay" placeholder="請選擇支付方式">
                <el-option label="esunbank-AliPay" value="1"></el-option>
                <el-option label="Paypal" value="2"></el-option>
                <el-option label="ecpay" value="3"></el-option>
                <el-option label="支付寶" value="6"></el-option>
                <el-option label="微信" value="7"></el-option>
                <!-- <el-option label="銀行匯款" value="5"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="訂單狀態" class="searchItem hidden-lg-and-down">
              <el-select v-model="listMenuForm.orderStatus" placeholder="請選擇訂單狀態">
                <el-option label="全部" value=""></el-option>
                <el-option label="待出貨" value="11"></el-option><!-- 已付款 -->
                <el-option label="已出貨" value="5"></el-option>
                <el-option label="訂單完成" value="6"></el-option>
                <el-option label="退件" value="10"></el-option>
                <el-option label="訂單取消" value="8"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-row class="ListMenu">
        <el-col :span="24">

          <el-form class="searchForm">
            <el-form-item label="訂單狀態" class="searchItem hidden-xl-only">
              <el-select v-model="listMenuForm.orderStatus" placeholder="請選擇訂單狀態">
                <el-option label="全部" value=""></el-option>
                <el-option label="待出貨" value="11"></el-option><!-- 已付款 -->
                <el-option label="已出貨" value="5"></el-option>
                <el-option label="訂單完成" value="6"></el-option>
                <el-option label="退件" value="10"></el-option>
                <el-option label="訂單取消" value="8"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="貨運單號" class="searchItem hidden-lg-and-down">
              <el-input v-model="listMenuForm.trackingNumber"
                        @change="listMenuForm.trackingNumber=listMenuForm.trackingNumber.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="開始時間" class="searchItem">
              <el-date-picker v-model="listMenuForm.startTime" type="datetime" placeholder="選擇時間"></el-date-picker>
            </el-form-item>
            <el-form-item label="結束時間" class="searchItem">
              <el-date-picker v-model="listMenuForm.endTime" type="datetime" placeholder="選擇時間"></el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <p class="recentlyTitle" @click="choiceTime">最近31天</p>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form class="searchForm">
            <el-form-item label="貨運單號" class="searchItem hidden-xl-only">
              <el-input v-model="listMenuForm.trackingNumber"
                        @change="listMenuForm.trackingNumber=listMenuForm.trackingNumber.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,'')"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap" style="justify-content:space-between;">
        <div style="display:flex;">
          <!-- <div class="btn" @click="uploadExcel">批量導入發貨</div> -->
          <!-- :data="{'applyId':this.listMenuForm.orderId}" -->

          <el-upload class="downloadTableBtn"
                     name='file'
                     ref="excelUpload"
                     :action=this.$GLOBAL.orderExcelPostUrl
                     :headers="{'Authorization': this.$cookie.get('auth')}"
                     :with-credentials="true"
                     :before-upload="beforeExcelUpload"
                     :on-remove="handleRemove"
                     :on-success='successExcel'
                     :on-error='errorExcel'
                     :show-file-list=false
                     :multiple="false"
                     :file-list="fileList"
                     :on-change="fileChange"
                     :on-exceed="handleExceed"
                     :limit="1">
            <span class="uploadSpan">批量上傳發貨</span>
          </el-upload>
          <div class="btn" @click="exportExcel">下載出貨excel</div>
        </div>

        <div style="display:flex;">
          <div class="btn" @click="search">查詢</div>
          <div class="btn borderBtn" @click="reset">重置</div>
        </div>

      </div>
      <div class="tableWrap orderListTable">
        <el-table :data="orderList" style="width:100%;" height='660px' stripe border>
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in orderTable" :key="'label'+index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
          <el-table-column label="詳情" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="toEdit(scope.row.orderNum, scope.row.detailId)" type="text">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
                       @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"
                       :current-page="currentPage"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="currentPageSize"
                       :pager-count='5'
                       layout="sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data() {
    return {
      navBlock: '訂單',
      navtitle: '扭蛋出貨',
      orderList: [],
      listMenuForm: {
        userAccount: '',
        orderId: '',
        payWay: '',
        trackingNumber: '',
        orderStatus: '',
        startTime: '',
        endTime: ''
      },
      orderTable: [
        {
          prop: 'orderStatus',
          label: '狀態',
          width: '100'
        },
        {
          prop: 'orderNum',
          label: '訂單編號',
          width: '170'
        }, {
          prop: 'memberDto.email',
          label: '用戶賬號',
          width: '170'
        }, {
          prop: 'memberDto.realname',
          label: '真實姓名',
          width: '100'
        }, {
          prop: 'receivePhone',
          label: '手機號碼',
          width: '130'
        }, {
          prop: 'area',
          label: '地區',
          width: '150'
        }, {
          prop: 'goodsName',
          label: '品項',
          width: '300'
        }, {
          prop: 'goodsDetail',
          label: '規格',
          width: '300'
        }, {
          prop: 'goodsAmount',
          label: '數量',
          width: '50'
        }, {
          prop: 'goodsRecievablePrice',
          label: '金額',
          width: '120'
        }, {
          prop: 'receiptsPrice',
          label: '總金額',
          width: '110'
        }, {
          prop: 'currency',
          label: '幣別',
          width: '50'
        },
        {
          prop: 'payMethod',
          label: '付款方式',
          width: '100'
        }, {
          prop: 'trackingNumber',
          label: '貨運單號',
          width: '170'
        },
        {
          prop: 'createTime',
          label: '訂單時間',
          width: '170'
        }
      ],
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      fileList: [],
      dialogVisible: false,
    }
  },
  created() {
    let _this = this;
    _this.getOrderList();
  },
  activated() {
    let _this = this;
    if (_this.listMenuForm.userAccount === '' &&
      _this.listMenuForm.orderId === '' &&
      _this.listMenuForm.payWay === '' &&
      _this.listMenuForm.trackingNumber === '' &&
      _this.listMenuForm.orderStatus === '' &&
      _this.listMenuForm.startTime === '' &&
      _this.listMenuForm.endTime === '' &&
      _this.currentPage === 1
    ) {
      _this.getOrderList();
    }
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取订单列表
    getOrderList() {
      let _this = this;
      let startTime, endTime;
      if (_this.listMenuForm.startTime === '' || _this.listMenuForm.startTime === null) {
        startTime = null;
      } else {
        startTime = _this.$formatDate(_this.listMenuForm.startTime)
      }
      if (_this.listMenuForm.endTime === '' || _this.listMenuForm.endTime === null) {
        endTime = null;
      } else {
        endTime = _this.$formatDate(_this.listMenuForm.endTime)
      }
      let param = {
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        userEmail: _this.listMenuForm.userAccount === '' ? null : _this.listMenuForm.userAccount,
        payMethod: _this.listMenuForm.payWay === '' ? null : _this.listMenuForm.payWay,
        startTime: startTime,
        trackingNumber: _this.listMenuForm.trackingNumber === '' ? null : _this.listMenuForm.trackingNumber,
        endTime: endTime,
        orderStatus: _this.listMenuForm.orderStatus === '' ? null : _this.listMenuForm.orderStatus,
        orderNum: _this.listMenuForm.orderId === '' ? null : _this.listMenuForm.orderId,
        orderType: 5
      }
      _this.$post('request/order/getDetialedOrderList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v => {
              // switch (v.payMethod) {
              //   case 'platform-ALIPAY':
              //     v.payMethod = '支付寶'
              //     break;
              //   case 'platform-WEIXIN':
              //     v.payMethod = '微信'
              //     break;
              //   default:
              //     v.payMethod = v.payMethod
              // }
              if (v.areaCode !== null) {
                v.receivePhone = '+' + v.areaCode + ' ' + v.receivePhone
              }
              v.area = ((v.country === null ? '' : v.country) + ' ' + (v.city === null ? '' : v.city) + '').toString();

            });
            _this.total = res.data.allRow;
            _this.orderList = res.data.list;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, 'error',
              function () {
                _this.dialogVisible = false;
              });
          }
        })
    },
    activated() {
      let _this = this;
      if ((_this.block === '' || _this.block === '0') &&
        _this.listMenuForm.startTime === '' &&
        _this.currentPage === 1) {
        _this.initList()
      }
    },
    // 最近31天
    choiceTime() {
      let _this = this
      var endTime = new Date();
      var startTime = new Date();
      startTime = startTime.getTime() - 3600 * 1000 * 24 * 31;
      _this.listMenuForm.startTime = new Date(startTime);
      _this.listMenuForm.endTime = endTime;
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getOrderList();
    },

    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.getOrderList();
    },

    // 查詢
    search() {
      let _this = this
      _this.currentPage = 1;
      _this.getOrderList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        userAccount: '',
        orderId: '',
        payWay: '',
        trackingNumber: '',
        orderStatus: '',
        startTime: '',
        endTime: ''
      }
      _this.currentPage = 1;
      _this.getOrderList();
    },
    // 修改详情
    toEdit(orderNum, id) {
      let _this = this
      _this.$router.push(`/outOrderDetails?orderNum=${orderNum}&id=${id}&navBlock=扭蛋`);
    },
    // excel
    // 上传excel之前回调函数
    beforeExcelUpload(file) {
      let _this = this;
      let result = _this.$checkData(file.name);
      if (file === '' && result === false) {
        _this.dialogVisible = true;
        _this.$propMessage('請選擇需要導入的Excel文件！', 'error', function () {
          _this.dialogVisible = false;
        });
        return false;
      }
      ;
    },
    // 上传excel超过限制回调函数
    handleExceed() {
      let _this = this;
      _this.dialogVisible = true;
      _this.$propMessage('最多上傳1個文件！', 'error', function () {
        _this.dialogVisible = false;
      });

    },
    // 移除excel
    handleRemove(file, fileList) {
      let _this = this;
      _this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this
      if (res.code === '00000') {
        _this.$propMessage('上傳成功', 'success');
        _this.$refs.excelUpload.clearFiles();
      } else {
        _this.$propMessage(res.message, 'error');
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.$propMessage(err.message + ',請重新上傳', 'error');
    },
    fileChange(file, fileList) {
      let _this = this;
      _this.fileList = fileList;
    },
    //導出excel
    exportExcel() {
      let _this = this;
      if (_this.listMenuForm.userAccount === '' && _this.listMenuForm.orderId === '' && _this.listMenuForm.payWay === '' && _this.listMenuForm.trackingNumber === '' && _this.listMenuForm.orderStatus === '' && (_this.listMenuForm.startTime === '' || _this.listMenuForm.startTime === null) && (_this.listMenuForm.endTime === '' || _this.listMenuForm.endTime === null)) {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入至少一個導出條件', 'error', function () {
          _this.dialogVisible = false;
        });

        return false;
      }
      ;

      if (_this.$compareTime(_this.listMenuForm.startTime, _this.listMenuForm.endTime)) {
        _this.dialogVisible = true;
        _this.$propMessage('開始時間不能晚於結束時間', 'error', function () {
          _this.dialogVisible = false;
        });

        return false;
      }
      ;

      if (_this.$compareTime(_this.listMenuForm.startTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage('開始時間不能是未來時間', 'error', function () {
          _this.dialogVisible = false;
        });
        return false
      }
      ;

      if (_this.$compareTime(_this.listMenuForm.endTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage('結束時間不能是未來時間', 'error', function () {
          _this.dialogVisible = false;
        });

        return false
      }
      ;

      if ((_this.listMenuForm.startTime === '' && _this.listMenuForm.endTime !== '') || (_this.listMenuForm.startTime !== '' && _this.listMenuForm.endTime === '')) {
        _this.dialogVisible = true;
        _this.$propMessage('請同時選擇開始時間和結束時間', 'error', function () {
          _this.dialogVisible = false;
        });

        return false
      }
      ;
      if ((_this.listMenuForm.startTime != '' && _this.listMenuForm.endTime != '') && (_this.listMenuForm.startTime != null && _this.listMenuForm.endTime != null)) {
        if ((_this.listMenuForm.endTime.getTime() - _this.listMenuForm.startTime.getTime()) > 3600 * 1000 * 24 * 31) {
          _this.dialogVisible = true;
          _this.$propMessage('最多可導出31天內訂單，請重新選擇', 'error', function () {
            _this.dialogVisible = false;
          });
          _this.listMenuForm.startTime = '';
          _this.listMenuForm.endTime = '';
          return false
        }
      }
      _this.downExcel();
    },
    downExcel() {
      let _this = this;
      _this.currentPage = 1;
      let startTime, endTime;
      let role = localStorage.getItem('testRole');
      if (_this.listMenuForm.startTime === '' || _this.listMenuForm.startTime === null) {
        startTime = '';
      } else {
        startTime = _this.$formatDate(_this.listMenuForm.startTime)
      }
      if (_this.listMenuForm.endTime === '' || _this.listMenuForm.endTime === null) {
        endTime = '';
      } else {
        endTime = _this.$formatDate(_this.listMenuForm.endTime)
      }

      // if (startTime === '' && endTime === '') {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('請選擇正確的時間進行訂單的導出', 'error', function () {
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // }

      //orderStatus下載待發貨的為11，已發貨的為5，已付款為2
      let url = '/request/order/exportOrderExcel?pageNo=' + _this.currentPage +
        '&pageSize=99999999' +
        '&orderType=5' +
        '&endTime=' + endTime +
        '&startTime=' + startTime +
        '&orderNum=' + (_this.listMenuForm.orderId === '' ? null : _this.listMenuForm.orderId) +
        '&orderStatus=' + (_this.listMenuForm.orderStatus === '' ? null : _this.listMenuForm.orderStatus) +
        '&payMethod=' + (_this.listMenuForm.payWay === '' ? null : _this.listMenuForm.payWay) +
        '&userEmail=' + (_this.listMenuForm.userAccount === '' ? null : _this.listMenuForm.userAccount) +
        '&trackingNumber=' + (_this.listMenuForm.trackingNumber === '' ? null : _this.listMenuForm.trackingNumber) +
        '&role=' + role;
      _this.$exportExcel(url, 'GET', {}, `扭蛋出貨${startTime.substring(0, 10)}-${endTime.substring(0, 10)}`);
    }
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;

    .ListMenu {
      display: flex;
    }

    .downloadTableBtn {
      // width: 1rem;
      // height: 0.35rem;
      // line-height: 0.35rem;
      // background: @mainColor;
      // color: #fff;
      // border-radius: 0.04rem;
      cursor: pointer;

      span {
        color: #fff;
        font-size: 0.12rem;
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      .cell {
        height: 100%;

        p {
          width: 100%;
        }

        p:last-child {
          border-bottom: none;
        }
      }

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }

    }
  }
}

@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;

      .searchItem {
        margin-right: 0.4rem;
      }
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/gashapon/gashaponList.vue